import { render, staticRenderFns } from "./RestoreItineraryVersionAlert.vue?vue&type=template&id=387b86ac&scoped=true&"
import script from "./RestoreItineraryVersionAlert.vue?vue&type=script&lang=js&"
export * from "./RestoreItineraryVersionAlert.vue?vue&type=script&lang=js&"
import style0 from "./RestoreItineraryVersionAlert.vue?vue&type=style&index=0&id=387b86ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387b86ac",
  null
  
)

export default component.exports